import { GlobalFilter } from '../../global/GlobalFilter';

export class ListFilter extends GlobalFilter {
  LabId?: number;
  ScanningCenterId?: number;
  CaseId?: number;
  EntityId?: number;
  EntityType?: string;
}
